function addToastContainerToBody($document, $compile, $rootScope, injectToastContainerOnBody) {
  if (injectToastContainerOnBody) {
    const $scope = $rootScope.$new();
    const elem = $compile('<og-toast-container class="og-msi og-fixed"></og-toast-container>')($scope);

    $document[0].querySelector('body').appendChild(elem[0]);
  }
}

addToastContainerToBody.$inject = ['$document', '$compile', '$rootScope', 'injectToastContainerOnBody'];

module.exports = addToastContainerToBody;
